import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=8a990ac6&scoped=true"
import script from "./SideMenuItem.vue?vue&type=script&lang=js"
export * from "./SideMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SideMenuItem.vue?vue&type=style&index=0&id=8a990ac6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a990ac6",
  null
  
)

export default component.exports